import type { LoginFormResponse } from '../LoginForm/types';

export interface MfaFormValues {
    digit1: number;
    digit2: number;
    digit3: number;
    digit4: number;
    digit5: number;
    digit6: number;
    code: number;
}

export enum MfaInputIdEnum {
    digit1 = 'digit1',
    digit2 = 'digit2',
    digit3 = 'digit3',
    digit4 = 'digit4',
    digit5 = 'digit5',
    digit6 = 'digit6',
    code = 'code',
}

export interface LoginResponse {
    data: { data: LoginFormResponse },
}

export interface MfaResponse {
    data: { data: boolean, error: unknown },
}
